<template>
  <div class="integration-section">
    <div class="grid-column ai-c jc-s sac__font-20 semi-bold">
      Create SmartAC.com Tag Type
      <SACTooltipItem class="margin-top-4" color="#727A8F" :icon-size="20">
        <template #tooltip>
          <div class="sac__font-12 med">
            Recommended Tag Type Name:
            <div class="sac__font-12 f-primary semi-bold">SmartAC.com Tag</div>
          </div>
        </template>
      </SACTooltipItem>
    </div>
    <div class="sac__font-14 margin-top-16">
      To identify customers and jobs associated with SmartAC.com, create a Tag Type in
      <a
        :href="tagHref"
        class="sac__font-16 f-primary med underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        ServiceTitan
      </a>
      . Enter the name of the Tag Type you created in the field below and submit it for
      verification.
    </div>
    <div class="grid-column even gap-16 margin-top-16">
      <SACInput
        placeholder="SmartAC.com Tag Name"
        field="tagName"
        :value="tagName"
        :change="changeField"
        :error="tagError"
      />
      <div v-if="saving">
        <img src="@shared/assets/img/general/loading.svg" alt="loading" />
      </div>
      <div v-else-if="tagTypeStId">
        <img src="@shared/assets/img/general/check-green.svg" alt="check" class="img-size-24" />
      </div>
      <div v-else>
        <button
          type="button"
          :disabled="isDisabled"
          :class="['sac__button-med bg-default', isDisabled ? 'disabled' : '']"
          @click="saveTagType"
        >
          Add Tag Type
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SACTooltipItem from '@shared/components/sac/SACTooltip.vue';
import SACInput from '@shared/components/sac/SACInput.vue';
import { mapState } from 'vuex';
import MapType from '@shared/lib/constant/MapType';

export default {
  name: 'AddTagType',
  components: {
    SACInput,
    SACTooltipItem,
  },
  data() {
    return {
      tagName: null,
      tagTypeStId: null,
      tagError: null,
      saving: false,
    };
  },
  watch: {
    tagName(oldVal, newVal) {
      if (newVal !== oldVal && this.tagName !== this.tagTypeMapping.internalId) {
        this.tagTypeStId = null;
      } else {
        this.tagTypeStId = this.tagTypeMapping.externalId;
        this.tagError = null;
      }
    },
    tagTypeMapping: {
      immediate: true,
      handler(newVal) {
        if (newVal?.internalId) {
          this.tagName = newVal.internalId;
          this.tagTypeStId = newVal.externalId;
        }
      },
    },
  },
  computed: {
    ...mapState({
      tagTypeMapping: (state) => state.serviceTitan.tagTypeMapping,
    }),
    tagHref() {
      return `${process.env.ST_URL}/#/Settings/tag-types/Add`;
    },
    isDisabled() {
      return !this.tagName || this.saving;
    },
  },
  methods: {
    changeField(f, v) {
      this[f] = typeof v === 'string' ? v.trim() : v;
    },
    async verifyTagName() {
      return await this.$store.dispatch('getSTTagTypeId', this.tagName);
    },
    async saveTagType() {
      this.saving = true;
      this.tagError = null;

      try {
        const serviceTitanTagId = await this.verifyTagName();
        if (!serviceTitanTagId) {
          this.tagError = 'Ensure that a tag type already exists in ServiceTitan';
          return;
        }

        this.tagTypeStId = serviceTitanTagId;
        const payload = [
          {
            ...this.tagTypeMapping,
            internalId: this.tagName,
            externalId: serviceTitanTagId,
            externalSource: 'Service Titan',
            mapType: MapType.TAG,
          },
        ];

        await this.$store.dispatch('saveMapping', payload);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
